/**
 * Identity Reducer that doens't mutate any state.
 */
export function identity<A>() {
  return <S>(state: S, _action: A) => state
}
